/**
 * Currency formatting utility ported from `ometrics-ai` (v1).
 * Used by free-shipping progress messaging (remaining amount).
 */
 
export function formatCurrency(amount, currencyInfo, conf) {
  if (typeof amount !== 'number' || Number.isNaN(amount)) return '0.00'
 
  const symbol = conf?.currency_symbol || '$'
  const position = conf?.currency_position || 'left'
  const thousandsSeparator = conf?.thousands_separator || ','
  const decimalSeparator = conf?.decimal_separator || '.'
 
  let decimalPlaces = 2
  let currencySymbol = symbol
 
  if (currencyInfo && typeof currencyInfo === 'object' && currencyInfo.symbol) {
    currencySymbol = currencyInfo.symbol
    decimalPlaces = currencyInfo.decimalPlaces || 2
  }
 
  const formattedAmount = amount.toFixed(decimalPlaces)
  const parts = formattedAmount.split('.')
  let integerPart = parts[0]
  const decimalPart = parts[1] || ''
 
  if (thousandsSeparator && integerPart.length > 3) {
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator)
  }
 
  const formattedNumber = decimalPart
    ? `${integerPart}${decimalSeparator}${decimalPart}`
    : integerPart
 
  return position === 'right'
    ? `${formattedNumber} ${currencySymbol}`
    : `${currencySymbol}${formattedNumber}`
}

